export function getSoftCardTheme(kind = "default") {
  switch (kind) {
    case "awaitingAmbulance":
      return {
        borderColor: "#ef4444",
        bgColor: "#fff1f2",
        titleColor: "#0f172a",
        textColor: "#334155",
        mutedColor: "#64748b",
        statusColor: "#b91c1c",
        dividerColor: "#fecdd3",
        buttonBg: "#ffffff",
        buttonBorder: "#fca5a5",
        buttonText: "#b91c1c",
        chipAddBg: "#fee2e2",
        chipAddBorder: "#fca5a5",
        chipAddText: "#b91c1c",
      };

    case "awaitingCourtesy":
      return {
        borderColor: "#eab308",
        bgColor: "#fefce8",
        titleColor: "#0f172a",
        textColor: "#334155",
        mutedColor: "#64748b",
        statusColor: "#a16207",
        dividerColor: "#fde68a",
        buttonBg: "#ffffff",
        buttonBorder: "#fde68a",
        buttonText: "#92400e",
        chipAddBg: "#fef3c7",
        chipAddBorder: "#fde68a",
        chipAddText: "#92400e",
      };

    case "queuedCourtesy":
      return {
        borderColor: "#94a3b8",
        bgColor: "#f8fafc",
        titleColor: "#0f172a",
        textColor: "#334155",
        mutedColor: "#64748b",
        statusColor: "#475569",
        dividerColor: "#cbd5e1",
        buttonBg: "#ffffff",
        buttonBorder: "#cbd5e1",
        buttonText: "#0f172a",
        chipAddBg: "#eef2ff",
        chipAddBorder: "#c7d2fe",
        chipAddText: "#4338ca",
      };

    case "atHQ":
      return {
        borderColor: "#22c55e",
        bgColor: "#f0fdf4",
        titleColor: "#0f172a",
        textColor: "#334155",
        mutedColor: "#64748b",
        statusColor: "#15803d",
        dividerColor: "#bbf7d0",
        buttonBg: "#ffffff",
        buttonBorder: "#bbf7d0",
        buttonText: "#166534",
        chipAddBg: "#ecfdf5",
        chipAddBorder: "#bbf7d0",
        chipAddText: "#166534",
      };

    case "transportingToHQ":
      return {
        borderColor: "#3b82f6",
        bgColor: "#eff6ff",
        titleColor: "#0f172a",
        textColor: "#334155",
        mutedColor: "#64748b",
        statusColor: "#1d4ed8",
        dividerColor: "#bfdbfe",
        buttonBg: "#ffffff",
        buttonBorder: "#bfdbfe",
        buttonText: "#1d4ed8",
        chipAddBg: "#eff6ff",
        chipAddBorder: "#bfdbfe",
        chipAddText: "#1d4ed8",
      };

    case "activeEmergency":
      return {
        borderColor: "#f97316",
        bgColor: "#fff7ed",
        titleColor: "#0f172a",
        textColor: "#334155",
        mutedColor: "#64748b",
        statusColor: "#c2410c",
        dividerColor: "#fdba74",
        buttonBg: "#ffffff",
        buttonBorder: "#fdba74",
        buttonText: "#c2410c",
        chipAddBg: "#fff7ed",
        chipAddBorder: "#fdba74",
        chipAddText: "#c2410c",
      };

    default:
      return {
        borderColor: "#cbd5e1",
        bgColor: "#ffffff",
        titleColor: "#0f172a",
        textColor: "#334155",
        mutedColor: "#64748b",
        statusColor: "#475569",
        dividerColor: "#e2e8f0",
        buttonBg: "#ffffff",
        buttonBorder: "#cbd5e1",
        buttonText: "#0f172a",
        chipAddBg: "#eef2ff",
        chipAddBorder: "#c7d2fe",
        chipAddText: "#4338ca",
      };
  }
}